const madeby = {
  name: "DAS Innovations",
  href: "https://das-innovations.de",
  src: "/media/das_clean.svg",
};

export default madeby;
